import React, { useState, useEffect ,useRef } from "react";
import L from "leaflet";
import LineGraph from "../Graphs/Line";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  
} from "react-leaflet";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { Checkbox,Button, Col, Row,notification } from "antd";
import Routing from "../MapRoutes/MapRoutes";

import "./Map_polilineas.scss";
import "leaflet/dist/leaflet.css";

export default function Map_polilineas(props) {

  const mapRef = useRef();

  const [checked, setchecked] = useState([]);
  const { coordenadas,noManaged } = props;
  var puntos = [];
  var puntos2 = [];
  var polilineas = [];
  var peso=[];
  var volumen=[];
  var altura=[]
  var difaltura=[]
  var rutas=[]
  var pendientes=[]


  var orden = "";
//  console.log('estas son las coordenadas',coordenadas);
  var color='white';
  var colorP='red';
  var dif=0;
  var difpen=0;
  var auxiliares=[];
  var auxiliare=[];

  var j=0;
  for (let i = 0; i < coordenadas.length; i++) {
    if(coordenadas[i].position=='begin'){
      auxiliare=[]
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
    }else if(coordenadas[i].position=='end'){
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      // auxiliares=[[...auxiliares,[coordenadas[i].punto1[0],coordenadas[i].punto1[1]]]]
      auxiliares=[...auxiliares,auxiliare]
      // j=j+1;
      
    }else{
      // auxiliares=[[...auxiliares,[coordenadas[i].punto1[0],coordenadas[i].punto1[1]]]]
        auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
    }
  }
  // console.log('auxiliares',auxiliares)

  for (let i = 0; i < coordenadas.length; i++) {
    if (filtrarTour(coordenadas[i].tour_info.order_tour, checked)) 
    { 
      puntos.push(coordenadas[i].punto1);
      
      //if(coordenadas[i].order_mode==='shipment')puntos.push(coordenadas[i].punto2)
      peso.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumWeight});
      volumen.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumItems});
      altura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:parseInt(coordenadas[i].punto1[2])});
      

      if ((i)!==coordenadas.length-1)
        {if(coordenadas[i+1].tour_info.order_pos!==0 ){
          var fromLatLng = L.latLng(coordenadas[i].punto1[0],coordenadas[i].punto1[1]);
          var toLatLng = L.latLng(coordenadas[i+1].punto1[0],coordenadas[i+1].punto1[1]);

          var dis = fromLatLng.distanceTo(toLatLng);
          

          dif=parseInt(coordenadas[i+1].punto1[2])-parseInt(coordenadas[i].punto1[2]);
          (dif===0 || dis ===0)?difpen=0:difpen= 100*dif/dis;
          pendientes.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:difpen})

          difaltura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:dif})
        }
      }
     
      if(coordenadas[i].tour_info.order_pos!==0 && coordenadas[i].hub==null){

        rutas.push(<Routing /* ref={routingRef} */ color={colorP} waypoints={puntos}/>)
       console.log('rutas: ',rutas)
        puntos=[];
        (colorP==='red')?colorP='green':(colorP==='green')?colorP='brown':colorP='red';
      }
      orden = orden + coordenadas[i].nombre + "-> ";
      if(coordenadas[i].order_mode==='delivery'){
        color='green';
      }else if(coordenadas[i].order_mode==='pickup'){
        color='red';
      }else if(coordenadas[i].order_mode==='shipment'){
        color='orange';
      }else{
        color='white';
      }

      
      if(i===coordenadas.length-1){
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           html: `<div class="hub-hidden">
           </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
               ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
      }else{
        puntos2.push(
          <Marker 
            icon={L.divIcon({
              html: (coordenadas[i].tour_info.order_pos===0 )
              ?`<div class="blue-square" ></div>`
              :`<div class="hub-hidden"></div>`,
            })}
            position={coordenadas[i].punto1}>
                <Popup  
                className="popUpHub"
                closeButton={false}
                >
                <div className="popUpHub-top">
                    {coordenadas[i].nombre} 
                  </div>
                <div className="popUpHub-in">
                  <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
                  <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
                  <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
                  <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
                  <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
                  <h4>Items en vehículo: {coordenadas[i].sumItems} </h4>
                  <h4>Peso de los items: {coordenadas[i].sumWeight} </h4>
                </div>
                
                </Popup> 
   
           </Marker> 
         );
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           
           html: (coordenadas[i].tour_info.order_pos===0  || coordenadas[i+1].tour_info.order_pos===0 )?`<div class="hub-hidden">
           </div>`
           :`<div class="marker-capillar">
              <div class="${color}-circle" >
              </div>
              <div class="number" >
                  ${coordenadas[i].tour_info.order_pos}
              </div>
              
              
            </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
                ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
         
      }
      
    }
  }

  var puntosNoMan=[]
  for (let i = 0; i < noManaged.length; i++) {
      // var color;
      // if(noManaged[i].order_mode==='delivery'){
      //   color='green';
      // }else if(noManaged[i].order_mode==='pickup'){
      //   color='red';
      // }else if(noManaged[i].order_mode==='shipment'){
      //   color='orange';
      // }else{
      //   color='white';
      // }

    puntosNoMan.push(
      <Marker 
      icon={L.divIcon({
        html: `<div class="marker-capillar-no">
          <div class="yellow-circle" >
          </div>
          <div class="number-no" >
              ${noManaged[i].order_id}
          </div>
        </div>`,
      })}
        position={coordenadas[i].punto1}>
           <Popup  closeButton={false}>
                NO MANAGED ORDER: {noManaged[i].order_name}
              </Popup>
        </Marker> 
      );  

  }
 

  const onChange = (checkedValues) => {
    setchecked(checkedValues);
  };

  function filtrarTour(value, checkboxs) {
    var tour_elegido = false;
    for (let i = 0; i < checkboxs.length; i++) {
      if (value === checkboxs[i]) {
        tour_elegido = true;
        break;
      }
    }
    return tour_elegido;
  }

  var num_tours_v = [];
  var aux= parseInt(coordenadas[coordenadas.length-1].tour_info.order_tour)+1; 
  
  for (let i = 0; i < aux; i++) {
    num_tours_v.push(<Checkbox value={i.toString()}>{i}</Checkbox>);
  }

  return (
    <>

    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.3/dist/leaflet.css"
     integrity="sha256-kLaT2GOSpHechhsozzB+flnD+zUyjE2LlfWPgU04xyI="
     crossOrigin=""/>
      <script src="https://unpkg.com/leaflet@1.9.3/dist/leaflet.js"
     integrity="sha256-WBkoXOwTeyKclOHuWtc+i2uENFpDZ9YPdf5Hf+D7ewM="
     crossOrigin=""></script>
     {
      (checked.length>0)
        ?<p>{orden}</p>
        :<div></div>
      }
      <div className="leyenda">
        <Checkbox.Group style={{marginBottom:'10px', width: "100%" }} onChange={onChange}>
          {num_tours_v}
        </Checkbox.Group>

            <div className="orange">
            </div>
            <div className="shipment">
            shipment
            </div>
            <div className="rojo">
            </div>
            <div className="pick-up">
            pick-up
            </div>
            <div className="verde">
            </div>
            <div className="delivery">
            delivery
            </div>
            <div className="azul">
            </div>
            <div className="hubs">
            hubs
            </div>
        </div>
      <div className="mapaRow">
        <MapContainer
          ref={mapRef}
          className="leaflet-container"
          center={coordenadas[0].punto1}
          zoom={12}
        >
          
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {rutas}
          {puntos2}
          {puntosNoMan}
        </MapContainer>
      </div>
      <div id="map"></div>

    </>
  );
}
